import { QueryKey } from '@tanstack/react-query';

/**
 * Keeps the last result on screen while the next one loads — a window, a filter or a page eases in
 * place instead of dropping to a spinner. Only within the same scope, though: the leading key parts
 * name the company (and, on a detail screen, the room or visitor), so data is never shown under a
 * subject it does not belong to.
 */
export const keepWithinScope =
  (scope: readonly unknown[]) =>
  <TData>(previous: TData | undefined, previousQuery?: { queryKey: QueryKey }): TData | undefined =>
    previousQuery && scope.every((part, index) => previousQuery.queryKey[index] === part)
      ? previous
      : undefined;
